angular.module('cvsApp').service('getChallengeQuestionsService',['networkService', 'configManager', 'getChallengeQuestionsModelAGPFormat', 'cvsAppData', function (NS, CM, GCQM, CAD) {

	function getChallengeQuestionsService (){
		this.getChallengeQuestionsdata = function(callBackSuccess){
			//get url
			var url = CM.getAGPAPIUrl('GET_CHALLENGE_QUESTIONS');

			var request = {url:url,
							header:{"Content-Type":"application/xml", Accept: 'application/xml'},
							data: getRequestBody(),
							onSuccess:callBackSuccess
						};
			cvsUtility.commonServiceCode(url,"getChallengeQuestions",GCQM,request,callBackSuccess,NS);
			
		};

		var getRequestBody = function () {
            
            var apikey = CAD.getApiKey() || cvsUtility.queryMap.apikey;
            var x2js = new X2JS();
            return x2js.json2xml_str({
                "getChallengeQuestionsRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "channelName": cvsUtility.queryMap.channel,
                            "lineOfBusiness": "Specialty",
                            "responseFormat": "XML"
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    }
                }
            });

        }
	}

	return new getChallengeQuestionsService();
}]);
